import React from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  centered?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  centered = true,
}) => (
  <div className={`mb-12 sm:mb-14 ${centered ? 'flex flex-col items-center text-center' : ''}`}>
    {eyebrow && (
      <span className="text-[#1f6f66] text-[11px] font-semibold uppercase tracking-[0.22em] mb-3 block">
        {eyebrow}
      </span>
    )}
    <h2 className="text-3xl sm:text-4xl font-medium serif text-[#14212b] tracking-tight">{title}</h2>
    <div
      className={`mt-5 h-px w-16 bg-[#1f6f66]/70 ${centered ? '' : ''}`}
      aria-hidden="true"
    />
  </div>
);

export default SectionHeading;
